
import { defineComponent } from "vue";
import LoginForm from "./LoginForm.vue";
import RecoverPass from "./RecoverPass.vue";

export default defineComponent({
  name: "App",
  components: { LoginForm, RecoverPass },
  data() {
    return {
      imgCliente: require("../../assets/logo_cliente_login.png"),
      imgImplanta: require("../../assets/implanta_login.png"),

      buttonLoading: false,

      ErrorLogin: false,

      mode: "login",

      title: "PAINEL SINCRONIA",

      slide_in: false,
      slide_out: false,

      recover_dialog: false,
    };
  },

  methods: {
    esqueceu() {
      this.slide_out = true;
      this.slide_in = false;

      setTimeout(() => {
        this.mode = "recover";
        this.title = "Recuperar senha";
        this.slide_in = true;
      }, 300);
    },

    resetLoginScreen() {
      this.slide_out = true;
      this.slide_in = false;

      setTimeout(() => {
        this.mode = "login";
        this.title = "PAINEL SINCRONIA";
        this.slide_in = true;
      }, 300);
    },
  },
});
